<template>
    <div class="modal fade" tabindex="-1" id="MeusDados" ref="modalMeusDados">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content meus-dados-modal">
                <div class="modal-body meus-dados-body">
                    <header class="meus-dados-header">
                        <div class="meus-dados-header__text">
                            <span class="meus-dados-header__eyebrow">Seus dados</span>
                            <h3 class="meus-dados-header__title">Atualize seu perfil</h3>
                            <p class="meus-dados-header__description">Mantenha suas informações sempre atualizadas para garantir a melhor experiência.</p>
                        </div>
                    </header>

                    <div class="meus-dados-content">
                        <aside class="meus-dados-avatar"
                               :class="{ 'meus-dados-avatar--has-image': usuario.urlImgFoto || imgCroped }">
                            <div class="meus-dados-avatar__wrapper">
                                <VueAnkaCropper :options="optionsCroper" @cropper-saved="enviaFotoPerfil" :remover="removerFoto" />
                            </div>

                            <div class="meus-dados-avatar__meta">
                                <strong class="meus-dados-avatar__title">Foto de perfil</strong>
                                <small class="meus-dados-avatar__hint">
                                    Formatos recomendados: JPG ou PNG até 5MB.
                                </small>

                                <button v-if="usuario.urlImgFoto || imgCroped"
                                        type="button"
                                        class="meus-dados-avatar__remove"
                                        @click="removerFoto">
                                    Remover foto
                                </button>
                            </div>
                        </aside>

                        <form class="meus-dados-form" id="formMeusDados">
                            <div class="meus-dados-grid">
                                <div class="meus-dados-form__group">
                                    <label class="meus-dados-form__label" for="Usuarios_nmUsuario">Nome</label>
                                    <input class="meus-dados-input" type="text" id="Usuarios_nmUsuario" name="usuario.nmUsuario" v-model="usuario.nmUsuario" maxlength="100" required>
                                </div>

                                <div class="meus-dados-form__group">
                                    <label class="meus-dados-form__label" for="Usuarios_dsEmail">E-mail</label>
                                    <input class="meus-dados-input" type="email" id="Usuarios_dsEmail" name="usuario.dsEmail" v-model="usuario.dsEmail" maxlength="100" required>
                                </div>

                                <div class="meus-dados-form__group">
                                    <label class="meus-dados-form__label" for="Usuarios_dsTelefone">Telefone</label>
                                    <vue-mask id="Usuarios_dsTelefone"
                                              class="meus-dados-input"
                                              name="usuario.dsTelefone"
                                              v-model="usuario.dsTelefone"
                                              mask="(00) 00000-0000"
                                              :raw="false"
                                              required>
                                    </vue-mask>
                                </div>

                                <div class="meus-dados-form__group">
                                    <label class="meus-dados-form__label" for="Usuarios_dsCelular">Celular</label>
                                    <vue-mask id="Usuarios_dsCelular"
                                              class="meus-dados-input"
                                              name="usuario.dsCelular"
                                              v-model="usuario.dsCelular"
                                              mask="(00) 00000-0000"
                                              :raw="false"
                                              required>
                                    </vue-mask>
                                </div>

                                <div class="meus-dados-form__group meus-dados-form__group--full">
                                    <label class="meus-dados-form__label" for="dtNascimento">Data de Nascimento</label>
                                    <vue-mask id="dtNascimento"
                                              class="meus-dados-input"
                                              name="usuario.dtNascimento"
                                              v-model="usuario.dtNascimento"
                                              mask="00/00/0000"
                                              :raw="false"
                                              :options="options" required>
                                    </vue-mask>
                                </div>
                            </div>

                            <button class="meus-dados-submit" type="button" :disabled="!liberaSalvar" @click="enviar">
                                <span>Salvar atualizações</span>
                            </button>
                        </form>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import VueAnkaCropper from '@/components/VueAnkaCropper'

    export default {
        name: 'MeusDados',
        components: {
            vueMask, VueAnkaCropper
        },
        data: function () {
            return {

                limiteCaracteres: 500,

                usuario: {
                    nmUsuario: null,
                    dsEmail: null,
                    dsTelefone: null,
                    dsCelular: null,
                    dtNascimento: null,
                },

                options: {
                    placeholder: '__/__/____',
                },

                optionsCroper: {
                    skin: 'sollicita',
                    dropareaMessage: 'Clique aqui para selecionar a imagem',
                    selectButtonLabel: 'Selecione',
                    cropArea: 'circle',
                    croppedHeight: 130,
                    croppedWidth: 130,
                    maxCropperHeight: 200,
                    saveButtonLabel: 'Aplicar',
                    resultQuality: 1,
                    previewQuality: 1,
                    imgDefault: null,
                },

                imgCroped: null,
                modal: null,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.nmUsuario == '' || this.usuario.nmUsuario == null) {
                    return false;
                }

                if (this.usuario.dsEmail == '' || this.usuario.dsEmail == null) {
                    return false;
                }

                if (this.usuario.dsTelefone == '' || this.usuario.dsTelefone == null) {
                    return false;
                }

                if (this.usuario.dsCelular == '' || this.usuario.dsCelular == null) {
                    return false;
                }

                if (this.usuario.dtNascimento == '' || this.usuario.dtNascimento == null) {
                    return false;
                }

                return true;
            },

            user() {
                return this.$store.state.user
            },

        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    const formData = new FormData();

                    if ($this.imgCroped != null) {
                        formData.append("dados.file", $this.imgCroped.croppedFile, $this.imgCroped.filename);
                    }

                    formData.append("dados.nmUsuario", $this.usuario.nmUsuario);
                    formData.append("dados.dsEmail", $this.usuario.dsEmail);
                    formData.append("dados.dsTelefone", $this.usuario.dsTelefone);
                    formData.append("dados.dsCelular", $this.usuario.dsCelular);
                    formData.append("dados.dtNascimento", $this.usuario.dtNascimento);
                    if ($this.usuario.urlImgFoto) {
                        formData.append("dados.urlImgFoto", $this.usuario.urlImgFoto);
                    }


                    axios.post(`${urlApi}/Auth/AlteraMeusDados`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Dados alterados com sucesso!");
                                $this.$store.commit('refreshUserProfile', {
                                    usuario: res.data.data.usuario,
                                    idContrato: res.data.data.idContrato,
                                    tpPessoa: res.data.data.tpPessoa,
                                    flCortesia: res.data.data.flCortesia,
                                })
                                $this.getDadosUser();
                            } else {
                                avisoErro("Não foi possível alterar seus dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            enviaFotoPerfil(dados) {
                let $this = this;
                $this.imgCroped = dados;
                $this.optionsCroper.imgDefault = $this.imgCroped.croppedImageURI;
            },

            getDadosUser() {
                let $this = this;
                axios.get(`${urlApi}/Auth/GetDadosUser`)
                    .then(res => {
                        if (res.data.success) {
                            res.data.data.usuario.idContrato = res.data.data.idContrato;
                            res.data.data.usuario.tpPessoa = res.data.data.tpPessoa;
                            res.data.data.usuario.flCortesia = res.data.data.flCortesia;
                            res.data.data.usuario.isAdmContrato = res.data.data.isAdmContrato;


                            $this.$store.commit('setUsuario', res.data.data.usuario);
                            if (res.data.data.usuarioApi != null) {
                                $this.$store.commit('setUsuarioApi', res.data.data.usuarioApi);
                                this.usuario = {
                                    nmUsuario: res.data.data.usuarioApi.nmUsuario,
                                    dsEmail: res.data.data.usuarioApi.dsEmail,
                                    dsTelefone: res.data.data.usuarioApi.dsTelefone,
                                    dsCelular: res.data.data.usuarioApi.dsCelular,
                                    dtNascimento: moment(res.data.data.usuarioApi.dtNascimento).format('DD/MM/YYYY'),
                                    urlImgFoto: res.data.data.usuarioApi.urlImgFoto
                                };
                                if (this.usuario.urlImgFoto) {
                                    this.optionsCroper.imgDefault = this.usuario.urlImgFoto;
                                }
                            } else {
                                this.usuario = {
                                    nmUsuario: res.data.data.usuario.nmUsuario,
                                    dsEmail: res.data.data.usuario.dsEmail,
                                    dsTelefone: res.data.data.usuario.dsTelefone,
                                    dsCelular: res.data.data.usuario.dsCelular,
                                    dtNascimento: moment(res.data.data.usuario.dtNascimento).format('DD/MM/YYYY'),
                                    urlImgFoto: null,
                                };
                            }

                        } else {
                            avisoErro("Não foi possível carregar seus dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar seus dados.");
                        }
                    });
            },

            checkForm() {
                var form = document.getElementById('formMeusDados')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.usuario.nmUsuario.length > 100) {
                        avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsEmail.length > 100) {
                        avisoErro("O limite de caracteres \"E-mail\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsTelefone.length > 100) {
                        avisoErro("O limite de caracteres \"Telefone\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsCelular.length > 100) {
                        avisoErro("O limite de caracteres \"Celular\" foi ultrapassado")
                        return false;
                    }
                }

                return true;
            },

            removerFoto() {
                let $this = this;
                $this.imgCroped = null;
                $this.optionsCroper.imgDefault = null;
                $this.usuario.urlImgFoto = null;
            },

            load() {
                this.getDadosUser();
            },

            close() {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalMeusDados);
                }
                this.modal.hide();
            }

        },
        mounted: function () {
            this.load();

            const esperaBoootstrap = () => {
                if (window.bootstrap && window.bootstrap.Modal) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalMeusDados);
                } else {
                    setTimeout(esperaBoootstrap, 50)
                }
            }
            this.$nextTick(() => esperaBoootstrap());
        },
        watch: {
            showModal: function () {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalMeusDados);
                }
                this.modal.show();

                this.load();
            },

        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css">
    /* Modal MEUS DADOS */
    .modal-lg {
        width: min(60vw, 960px);
        max-width: min(60vw, 960px);
        margin: 0 auto;
    }

    .meus-dados-modal {
        border: none;
        border-radius: 28px;
        /*overflow: hidden;*/
        background: linear-gradient(145deg, #f9fbff 0%, #eef2ff 40%, #ffffff 100%);
        box-shadow: 0 30px 80px -20px rgba(21, 38, 78, 0.25);
    }

    .meus-dados-body {
        padding: 40px clamp(24px, 5vw, 56px);
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .meus-dados-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 32px;
        position: relative;
    }

    .meus-dados-header__text {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: #1d2533;
    }

    .meus-dados-header__eyebrow {
        font-size: 0.75rem;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        font-weight: 600;
        color: #4c5b8f;
    }

    .meus-dados-header__title {
        font-size: clamp(1.5rem, 2.2vw, 2rem);
        font-weight: 700;
        margin: 0;
    }

    .meus-dados-header__description {
        margin: 0;
        color: #57617a;
        font-size: 0.95rem;
        line-height: 1.5;
    }

    .meus-dados-content {
        display: grid;
        grid-template-columns: clamp(220px, 26%, 260px) 1fr;
        gap: clamp(24px, 3vw, 40px);
        align-items: flex-start;
    }

    .meus-dados-avatar {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 24px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.7);
        box-shadow: inset 0 0 0 1px rgba(76, 112, 255, 0.15);
        backdrop-filter: blur(6px);
    }

    .meus-dados-avatar__wrapper {
        width: 100%;
        max-width: 260px;
        margin: 0 auto;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .meus-dados-avatar__meta {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .meus-dados-avatar__hint {
        text-align: center;
        color: #6b7590;
        font-size: 0.8rem;
        line-height: 1.4;
    }

    .meus-dados-avatar__title {
        font-size: 0.9rem;
        color: #1f2a44;
    }

    .meus-dados-avatar__remove {
        margin-top: 4px;
        background: none;
        border: none;
        color: #d63939;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        cursor: pointer;
        padding: 0;
        text-decoration: none;
        transition: color 0.15s ease;
    }

        .meus-dados-avatar__remove:hover {
            color: #b02121;
        }

    /* FORM DA DIREITA */
    .meus-dados-form {
        display: flex;
        flex-direction: column;
        gap: 24px;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 20px;
        padding: clamp(24px, 4vw, 36px);
        box-shadow: inset 0 0 0 1px rgba(76, 112, 255, 0.1);
    }

    .meus-dados-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
        gap: 20px;
    }

    /* Responsivo - Telas médias */
    @media (max-width: 1200px) and (min-width: 993px) {
        .meus-dados-grid {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 18px;
        }
    }

    .meus-dados-form__group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .meus-dados-form__group--full {
        grid-column: 1 / -1;
    }

    .meus-dados-form__label {
        font-weight: 600;
        font-size: 0.9rem;
        color: #1f2a44;
    }

    .meus-dados-input {
        width: 100%;
        border-radius: 12px;
        border: 1px solid rgba(76, 112, 255, 0.25);
        background: rgba(255, 255, 255, 0.9);
        padding: 12px 16px;
        font-size: 0.95rem;
        color: #1f2a44;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

        .meus-dados-input:focus,
        .meus-dados-input:focus-visible {
            outline: none;
            border-color: rgba(76, 112, 255, 0.55);
            box-shadow: 0 0 0 4px rgba(76, 112, 255, 0.15);
        }

        .meus-dados-input[disabled],
        .meus-dados-input:disabled {
            background: rgba(243, 244, 248, 0.7);
            color: #9aa3c2;
        }

    .meus-dados-submit {
        border: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border-radius: 14px;
        padding: 16px 22px;
        font-weight: 600;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        background: linear-gradient(135deg, #4f7bff 0%, #2745d8 100%);
        color: #ffffff;
        box-shadow: 0 15px 30px -12px rgba(39, 69, 216, 0.55);
        transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
        cursor: pointer;
    }

        .meus-dados-submit:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 18px 36px -14px rgba(39, 69, 216, 0.6);
            filter: brightness(1.05);
        }

        .meus-dados-submit:disabled {
            cursor: not-allowed;
            background: linear-gradient(135deg, #b8c4ff 0%, #9baaff 100%);
            box-shadow: none;
            opacity: 0.75;
        }

    .meus-dados-close {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: none;
        background: rgba(255, 255, 255, 0.7);
        box-shadow: 0 12px 24px -16px rgba(21, 38, 78, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    }

        .meus-dados-close:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 30px -18px rgba(21, 38, 78, 0.5);
            background: rgba(255, 255, 255, 0.9);
        }

        .meus-dados-close svg {
            width: 18px;
            height: 18px;
            fill: #1d2533;
        }

    /* crop */
    #MeusDados .ankaCropper.sollicita {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 8px 0 4px;
        color: #0b193b;
        font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }

        #MeusDados .ankaCropper.sollicita .ankaCropper__droparea {
            position: relative;
            width: 190px;
            height: 190px;
            margin: 0 auto;
            border-radius: 50%;
            border: 2px dashed rgba(76, 112, 255, 0.7);
            background: radial-gradient(circle at top, rgba(76, 112, 255, 0.1), transparent 70%), rgba(255, 255, 255, 0.95);
            box-shadow: 0 10px 30px -15px rgba(21, 38, 78, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 10px 18px;
            font-size: 14px;
            font-weight: 500;
            color: #2745d8;
            overflow: hidden;
            transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease, background 0.2s ease;
        }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea:hover {
                border-color: rgba(39, 69, 216, 0.9);
                box-shadow: 0 15px 40px -18px rgba(21, 38, 78, 0.55);
                background: radial-gradient(circle at top, rgba(76, 112, 255, 0.18), transparent 70%), rgba(255, 255, 255, 0.98);
                transform: translateY(-1px);
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea > button {
                position: absolute;
                top: 6px;
                right: 6px;
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea::before {
                content: none;
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea span,
            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea p {
                font-size: 12px;
                line-height: 1.4;
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea > svg {
                position: absolute;
                top: 6px;
                right: 6px;
                width: 16px;
                height: 16px;
                cursor: pointer;
                z-index: 2;
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea img,
            #MeusDados .ankaCropper.sollicita .ankaCropper__droparea canvas {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }

        #MeusDados .ankaCropper.sollicita .ankaCropper__previewArea {
            height: 200px !important;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navigation {
            margin: 14px auto 0;
            background: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            padding: 4px 0;
            flex-wrap: wrap;
            max-width: 190px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navButton {
            width: 32px;
            height: 32px;
            padding: 0;
            border-radius: 999px;
            background: rgba(39, 69, 216, 0.08);
            border: none;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.15s ease;
        }

            #MeusDados .ankaCropper.sollicita .ankaCropper__navButton:hover {
                background: rgba(39, 69, 216, 0.18);
                box-shadow: 0 8px 18px -10px rgba(21, 38, 78, 0.45);
                transform: translateY(-1px);
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__navButton svg {
                width: 18px;
                height: 18px;
                stroke: #2745d8;
            }

        #MeusDados .ankaCropper.sollicita .ankaCropper__saveButton,
        #MeusDados .ankaCropper.sollicita .ankaCropper__selectButton {
            padding: 10px 18px;
            font-size: 13px;
            border-radius: 999px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
        }

            #MeusDados .ankaCropper.sollicita .ankaCropper__saveButton:hover,
            #MeusDados .ankaCropper.sollicita .ankaCropper__selectButton:hover {
                transform: translateY(-1px);
                box-shadow: 0 14px 26px -16px rgba(39, 69, 216, 0.75);
                filter: brightness(1.05);
            }

            #MeusDados .ankaCropper.sollicita .ankaCropper__saveButton svg,
            #MeusDados .ankaCropper.sollicita .ankaCropper__selectButton svg {
                vertical-align: middle;
            }
    /* RESPONSIVO - Tablet */
    @media (max-width: 992px) {
        .modal-lg {
            width: min(95vw, 800px);
            max-width: min(95vw, 800px);
            margin: 0.5rem auto;
        }

        .meus-dados-body {
            padding: clamp(28px, 4vw, 40px) clamp(20px, 4vw, 40px);
            gap: 28px;
        }

        .meus-dados-content {
            grid-template-columns: 1fr;
            gap: clamp(20px, 3vw, 32px);
        }

        .meus-dados-avatar {
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 20px;
            padding: 20px;
        }

        .meus-dados-avatar__wrapper {
            width: 140px;
            max-width: 140px;
            flex-shrink: 0;
        }

        .meus-dados-avatar__meta {
            align-items: flex-start;
            flex: 1;
        }

        .meus-dados-avatar__hint {
            max-width: 100%;
            text-align: left;
        }

        .meus-dados-form {
            padding: clamp(20px, 3vw, 32px);
        }

        .meus-dados-grid {
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 18px;
        }
    }

    /* RESPONSIVO - Mobile */
    @media (max-width: 768px) {
        .modal-lg {
            width: calc(100vw - 1rem);
            max-width: calc(100vw - 1rem);
            margin: 0.5rem;
        }

        .meus-dados-body {
            padding: 24px 18px;
            gap: 24px;
        }

        .meus-dados-header {
            gap: 16px;
        }

        .meus-dados-header__title {
            font-size: clamp(1.25rem, 5vw, 1.75rem);
        }

        .meus-dados-header__description {
            font-size: 0.9rem;
        }

        .meus-dados-content {
            gap: 20px;
        }

        .meus-dados-avatar {
            flex-direction: column;
            align-items: center;
            padding: 18px;
            gap: 16px;
        }

        .meus-dados-avatar__wrapper {
            width: 120px;
            max-width: 120px;
        }

        .meus-dados-avatar__meta {
            align-items: center;
        }

        .meus-dados-avatar__hint {
            text-align: center;
            font-size: 0.75rem;
        }

        .meus-dados-form {
            padding: 18px;
            gap: 20px;
        }

        .meus-dados-grid {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        .meus-dados-form__group--full {
            grid-column: 1;
        }

        .meus-dados-input {
            padding: 11px 14px;
            font-size: 0.9rem;
        }

        .meus-dados-submit {
            width: 100%;
            padding: 14px 20px;
            font-size: 0.95rem;
        }

        /* Ajustes do cropper em mobile */
        #MeusDados .ankaCropper.sollicita .ankaCropper__droparea {
            width: 150px;
            height: 150px;
            font-size: 12px;
            padding: 8px 14px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__previewArea {
            height: 160px !important;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navigation {
            max-width: 150px;
            gap: 6px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navButton {
            width: 28px;
            height: 28px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navButton svg {
            width: 16px;
            height: 16px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__saveButton,
        #MeusDados .ankaCropper.sollicita .ankaCropper__selectButton {
            padding: 8px 16px;
            font-size: 12px;
        }
    }

    /* RESPONSIVO - Mobile Pequeno */
    @media (max-width: 576px) {
        .modal-lg {
            width: calc(100vw - 0.5rem);
            max-width: calc(100vw - 0.5rem);
            margin: 0.25rem;
        }

        .meus-dados-body {
            padding: 20px 16px;
            gap: 20px;
        }

        .meus-dados-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }

        .meus-dados-header__eyebrow {
            font-size: 0.7rem;
        }

        .meus-dados-header__title {
            font-size: 1.35rem;
        }

        .meus-dados-header__description {
            font-size: 0.85rem;
        }

        .meus-dados-content {
            gap: 18px;
        }

        .meus-dados-avatar {
            padding: 16px;
            gap: 14px;
        }

        .meus-dados-avatar__wrapper {
            width: 110px;
            max-width: 110px;
        }

        .meus-dados-avatar__title {
            font-size: 0.85rem;
        }

        .meus-dados-avatar__hint {
            font-size: 0.7rem;
        }

        .meus-dados-avatar__remove {
            font-size: 0.75rem;
        }

        .meus-dados-form {
            padding: 16px;
            gap: 18px;
        }

        .meus-dados-grid {
            gap: 14px;
        }

        .meus-dados-form__label {
            font-size: 0.85rem;
        }

        .meus-dados-input {
            padding: 10px 12px;
            font-size: 0.85rem;
        }

        .meus-dados-submit {
            padding: 12px 18px;
            font-size: 0.9rem;
        }

        /* Ajustes do cropper em mobile pequeno */
        #MeusDados .ankaCropper.sollicita .ankaCropper__droparea {
            width: 130px;
            height: 130px;
            font-size: 11px;
            padding: 6px 12px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__previewArea {
            height: 140px !important;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navigation {
            max-width: 130px;
            margin-top: 10px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navButton {
            width: 26px;
            height: 26px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__navButton svg {
            width: 14px;
            height: 14px;
        }

        #MeusDados .ankaCropper.sollicita .ankaCropper__saveButton,
        #MeusDados .ankaCropper.sollicita .ankaCropper__selectButton {
            padding: 7px 14px;
            font-size: 11px;
        }
    }

    /* Ajuste do botão de fechar em mobile */
    @media (max-width: 768px) {
        .btn.position-absolute.top-0.end-0 {
            top: 8px !important;
            right: 8px !important;
            margin-top: 0 !important;
            margin-right: 0 !important;
            width: 36px;
            height: 36px;
            padding: 0;
        }

        .btn.position-absolute.top-0.end-0 svg {
            width: 14px;
            height: 14px;
        }
    }

    @media (max-width: 576px) {
        .btn.position-absolute.top-0.end-0 {
            top: 6px !important;
            right: 6px !important;
            width: 32px;
            height: 32px;
        }

        .btn.position-absolute.top-0.end-0 svg {
            width: 12px;
            height: 12px;
        }
    }
</style>



